module.exports = __webpack_public_path__ + "static/media/OrderForm.18214184.jpg";